import { RJSFSchema } from "shared/types/RJSF"

export function getAddonVariantKeys(
  addonsSchema: RJSFSchema | undefined | null,
  addonVariantKeys: string[] | null | undefined
): Record<string, string> {
  if (!addonsSchema?.properties) {
    return {}
  }
  return Object.fromEntries(
    Object.entries(addonsSchema?.properties)
      .map(([configurationID, schema]) => {
        if (!schema.properties?.product?.properties) {
          return null
        }
        const productType = Object.values(
          schema.properties.product.properties
        ).find(property => property.fieldID?.endsWith("value_01"))?.default

        if (!productType || typeof productType !== "string") {
          return null
        }
        const addonVariantKey = addonVariantKeys?.find(variantKey =>
          variantKey.startsWith(productType)
        )
        if (!addonVariantKey) {
          return null
        }
        return [configurationID, addonVariantKey]
      })
      .filter(Boolean) as [string, string][]
  )
}
